import styled from 'styled-components'
import { colors } from 'client/styles'

export const ShowMoreBase = styled.span`
  align-items: center;
  color: ${colors.grey1};
  cursor: pointer;
  display: flex;
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;

  svg {
    margin-inline-start: 8px;
    fill: ${colors.grey1};
  }
`
